const axios = require('axios').default;

const HTTP = axios.create({
  baseURL: `${process.env.VUE_APP_API_PATH}:${process.env.VUE_APP_API_PORT}`,
  // timeout: 180000,
});

HTTP.interceptors.request.use((config) => {
  const cf = config;
  cf.headers.th = localStorage.getItem('mbth');
  console.log(`headers th ${cf.headers.th}`);
  return cf;
});

export default HTTP;
